import { render, staticRenderFns } from "./DouYinUserInfo.vue?vue&type=template&id=df4b11f4&scoped=true"
import script from "./DouYinUserInfo.vue?vue&type=script&lang=js"
export * from "./DouYinUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4b11f4",
  null
  
)

export default component.exports